import React from 'react';

export const Logo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
    >
      {/* Outer circle */}
      <circle cx="50" cy="50" r="45" strokeOpacity="0.5" />

      {/* Stylized Compass/Star */}
      {/* Main axes */}
      <path d="M50 15 V85" strokeWidth="2" strokeOpacity="0.8" />
      <path d="M15 50 H85" strokeWidth="2" strokeOpacity="0.8" />

      {/* Diagonal axes */}
      <path d="M25 25 L75 75" strokeWidth="1.5" strokeOpacity="0.6" />
      <path d="M25 75 L75 25" strokeWidth="1.5" strokeOpacity="0.6" />

      {/* Central element - a stylized star or gem */}
      <path
        d="M50 40 L55 50 L50 60 L45 50 Z"
        fill="currentColor"
        stroke="none"
      />
      <path
        d="M40 50 L50 45 L60 50 L50 55 Z"
        fill="currentColor"
        stroke="none"
        strokeOpacity="0.7"
      />
    </svg>
  );
};